import { ALGOLIA_ATTRIBUTES } from '@shared/utils/src/algolia/algoliaAttributes';

/**
 * Helper to extract the base attribute name from a potentially localized Algolia attribute
 *
 * @param attribute The potentially localized attribute name
 * @returns The base attribute name without locale
 */

export const getBaseAttribute = (attribute: string): string => {
  const allBaseAttributes = Object.values(ALGOLIA_ATTRIBUTES);
  const sortedAttributes = [...allBaseAttributes].sort((a, b) => b.length - a.length);
  const matchedAttribute = sortedAttributes.find((baseAttribute) => attribute.includes(baseAttribute));
  return matchedAttribute || attribute;
};
